"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CONFIG_RETRY = {
    threshold: 2,
    baseDelay: 100,
    backoffFactor: 2,
    fuzzFactor: 0
};
exports.default = CONFIG_RETRY;
//# sourceMappingURL=CONFIG_RETRY.js.map